import { SubscriptionTierEntity } from '../../../../meta-data/app-meta-data.service';
import { SubscriptionPriceResult } from '../subscription-price-result.model';

export function filterEligibleSubscriptionTiers(
  tiers: SubscriptionTierEntity[], pricing: SubscriptionPriceResult
): SubscriptionTierEntity[] {
  if (!pricing || !pricing.IsSuccess) {
    return [];
  }

  const eligibleIds = new Set((pricing.TierPricing || [])
    .filter(item => item.SubscriptionTier && item.SubscriptionTier.SubscriptionTierId != null)
    .map(item => item.SubscriptionTier.SubscriptionTierId));

  return (tiers || []).filter(tier => eligibleIds.has(tier.SubscriptionTierId));
}
